import React, { Fragment, useEffect, useState } from "react"
import { Row, Card, Col, Button } from "react-bootstrap"
import "../../assets/styles/papeleta.css"
import { sendVotos } from "../../services/user.service"
import { toast } from "react-toastify"
import { useHistory, withRouter } from "react-router-dom"
import Loader from "../shared/Loader"
import ModalConfirmaVoto from "./ModalConfirmaVoto"

const Papeleta = ({ votacion }) => {
	const [seleccionados, setSeleccionados] = useState([])
	const history = useHistory()
	const [loader, setLoader] = useState()
	const [showModal, setShowModal] = useState(false)
	const { candidatos } = votacion

	const confirmarVoto = () => {
		setShowModal(true)
	}
	const emitirVoto = async () => {
		setLoader(true)
		const req = await sendVotos(votacion.id, seleccionados)
		console.log(req)
		if (req?.response === "success") {
			await toast.success(`${req.message}`)
		} else {
			await toast.error(`Ha ocurrido un error. ${req?.message}`)
		}
		setLoader(false)

		return history.push("/votaciones")
	}

	const selectVoto = candidato => () => {
		console.log("seleccionado voto", candidato)
		if (seleccionados.includes(candidato)) {
			console.log("El candidato ya está", candidato)
			setSeleccionados(seleccionados.filter(x => x !== candidato))
		} else {
			setSeleccionados([...seleccionados, candidato])
		}
	}

	const generateCards = () => {
		return candidatos?.map((x, index) => {
			return (
				<Col lg={3} key={index} className="mb-3">
					<Card className=" text-center">
						<Card.Body>
							<Card.Title>{x.nombre}</Card.Title>
						</Card.Body>
						<Card.Footer style={{ cursor: "pointer" }} onClick={selectVoto(x.id)}>
							<div className="container-linea">
								<div className="line"></div>
								{seleccionados.includes(x.id) && <div className="vertical-line"></div>}
							</div>
						</Card.Footer>
					</Card>
				</Col>
			)
		})
	}
	if (candidatos) {
		return (
			<Fragment>
				<Row className="justify-content-center">{generateCards()}</Row>
				<Row className="mt-5">
					<Col lg={{ span: 4, offset: 4 }} className="justify-content-center">
						{loader ? (
							<Loader />
						) : candidatos.length === 0 ? (
							<Fragment>
								<p>Esta elección no tiene candidatos asignados</p>
								<Button variant="secondary" size="md" block onClick={() => history.goBack()}>
									Volver
								</Button>
							</Fragment>
						) : (
							<Fragment>
								<Button onClick={confirmarVoto} size="lg" block>
									Votar
								</Button>
								<hr />
								<Button variant="secondary" size="md" block onClick={() => history.goBack()}>
									Volver
								</Button>
							</Fragment>
						)}
					</Col>
				</Row>
				<ModalConfirmaVoto
					loader={loader}
					show={showModal}
					setShow={setShowModal}
					emitirVoto={emitirVoto}
				/>
			</Fragment>
		)
	} else {
		return <Loader />
	}
}

export default withRouter(Papeleta)
